import { render, staticRenderFns } from "./BinEditModal.vue?vue&type=template&id=1307d45c"
import script from "./BinEditModal.vue?vue&type=script&lang=ts"
export * from "./BinEditModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports